// jshint esversion: 6
import cookie from 'vue-cookie';
import webHelper from '../helpers/web';

export default {
  // Post form data for auth
  async login(vm, authData) {
    const path = process.env.NODE_ENV === 'development' ?
      'http://localhost:3000/login' : '/login';
    const res = await webHelper.post(vm, path, authData);
    if (res.failed) return null;
    // Save uuid to Cookie
    cookie.set('uuid', res.sessionHash, { expires: '8h' });
    cookie.set('role', res.role, { expires: '8h' });
    return res.role;
  },

  // Removes uuid, which logs the user out
  async logout() {
    cookie.delete('uuid');
    cookie.delete('role');
    await webHelper.post('logout');
  },

  role() {
    return cookie.get('role');
  },

  // Check if uuid exists
  isLoggedIn() {
    const id = cookie.get('uuid');
    return id || false;
  },

  // Check if user role matches required role
  isAllowed(role) {
    return role <= parseInt(cookie.get('role'), 10);
  },
};



// WEBPACK FOOTER //
// ./src/auth/index.js